// Inspectable supporting-evidence side panel. The sort is a CLEARLY-LABELED
// deterministic view-model (recency or |value|), NEVER a fabricated relevance score.
import React, { useState } from "react";
import { sortEvidence, EVIDENCE_SORTS } from "../lib/evidenceViewModel";
import { EmptyState } from "../BrainStates";

export default function EvidencePanel({ evidence }) {
  const [by, setBy] = useState("recency");
  const { rows, sortLabel } = sortEvidence(evidence, by);

  return (
    <div data-testid="evidence-panel" className="rounded-lg border border-slate-800 bg-slate-900/60 p-4">
      <div className="mb-2 flex items-center justify-between">
        <h4 className="text-sm font-semibold text-slate-200">Supporting evidence</h4>
        <select
          aria-label="Sort evidence"
          data-testid="evidence-sort"
          value={by}
          onChange={(e) => setBy(e.target.value)}
          className="rounded-md border border-slate-700 bg-slate-800 px-2 py-1 text-xs text-slate-200"
        >
          {Object.values(EVIDENCE_SORTS).map((s) => (
            <option key={s.key} value={s.key}>
              {s.key}
            </option>
          ))}
        </select>
      </div>
      <p className="mb-2 text-[11px] text-slate-500" data-testid="evidence-sort-label">
        {sortLabel} — view-model ordering, not a relevance score
      </p>
      {rows.length === 0 ? (
        <EmptyState title="No evidence rows" testId="evidence-empty" />
      ) : (
        <ul className="space-y-1.5">
          {rows.map((r, i) => (
            <li key={`${r.collection}:${r.ref_id}:${r.field}:${i}`} className="rounded-md bg-slate-800/40 p-2 text-xs" data-testid="evidence-row">
              <div className="flex justify-between gap-2">
                <span className="text-slate-300">{r.field}</span>
                <span className="text-slate-100">{String(r.value)}</span>
              </div>
              <div className="mt-0.5 flex justify-between text-[10px] text-slate-500">
                <span>{r.collection} · {r.ref_id}</span>
                <span>{r.as_of || "no timestamp"}</span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
